import { Component } from '@angular/core';

@Component({
  selector: 'app-welcome-component',
  templateUrl: './welcome-component.component.html',
  styleUrl: './welcome-component.component.scss'
})
export class WelcomeComponentComponent {
 services = [
    {
      title: 'إرسال مستندات لإتمام الخدمات',
      img: '../../../assets/service3.png.png',
      link: '/Arabic/eServices/Pages/Services.aspx?DepartmentID=23'
    },

    {
      title: 'الرخصة الذهيبة',
      img: '../../../assets/service3.png.png',
      link: '/Arabic/eServices/Pages/Services.aspx?DepartmentID=18'
    },
        {
      title: 'المسئولية المجتمعية للشركات/الاستدامة',
      img: '../../../assets/service3.png.png',
      link: '/Arabic/eServices/Pages/Services.aspx?DepartmentID=22'
    },
    {
      title: 'خدمات تأسيس الشركات',
      img: '../../../assets/service3.png.png',
      link: '/Arabic/eServices/Pages/Services.aspx?DepartmentID=1'
    },
    {
      title: 'خدمات الجمعيات',
      img: '../../../assets/service3.png.png',
      link: '/Arabic/eServices/Pages/Services.aspx?DepartmentID=2'
    }
  ];

  slideConfig = {
    rtl: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    arrows: false,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } }
    ]
  };
}